'use client'

import DesktopLayout from './components/desktop-layout'
import MobileLayout from './components/mobile-layout'
import useCarouselState from '../../hooks/use-carousel-state'
import { useIsMobile } from '@/app/util/use-media-query'

const Carousel = () => {
    const isMobile = useIsMobile()
    const state = useCarouselState()

    if (isMobile) {
        return <MobileLayout state={state} />
    }

    return <DesktopLayout state={state} />
}

export default Carousel
